export class ProfileHelpers {
    static getVehicleType(profile) {
        return profile.substring(0, profile.indexOf("."));
    }
}
